<template>
    <div
        v-if="$auth.loggedIn && !loading"
        :class="{ transparent: !$vuetify.theme.dark }"
    >
        <!-- title-component -->
        <v-card class="favorites">
            <v-container>
                <v-row>
                    <v-col
                        class="py-0 px-0"
                        :class="{ white: !$vuetify.theme.dark }"
                    >
                        <!-- game name -->
                        <!-- <div v-if="isEmpty && !loading" class="pa-5">
            <v-alert dense border="left" outlined type="warning">
              You haven't added anything to favorites.
            </v-alert>
          </div> -->
                        <!-- v-if="favorites.length > 0" -->
                        <v-sheet
                            class="pa-2 fav-tab primary text-uppercase white--text d-flex align-items-center justify-content-start caption sub-header"
                        >
                            <!-- <v-icon size="30" color="white">mdi-star-online</v-icon> -->
                            <!-- <v-icon>mdi-star-outline</v-icon> -->
                            <v-icon size="20">mdi-star</v-icon>
                            <span class="px-2 pt-1">Favorites</span>
                        </v-sheet>
                        <v-card-text
                            v-if="!favorites.length"
                            class="text-center"
                            dense
                        >
                            <v-btn
                                icon
                                color="amber"
                                class="align-self-center"
                                height="35"
                            >
                                <v-icon
                                    size="25"
                                    :color="
                                        !$vuetify.theme.dark ? 'black' : 'white'
                                    "
                                    >mdi-plus-circle-outline</v-icon
                                >
                            </v-btn>
                            <!-- <v-icon size="30" color="white">mdi-star-online</v-icon> -->
                            <div class="py-2">
                                Add to favorite
                                <!-- Add to favorite to see your favorite markets -->
                            </div>
                        </v-card-text>
                        <v-skeleton-loader
                            v-if="loading"
                            tile
                            light
                            dense
                            type="list-item-two-line"
                        >
                        </v-skeleton-loader>
                        <div v-for="(favorite, i) in favorites" :key="i">
                            <v-tab
                                class="body-2 primary--text text-uppercase font-weight-bold caption pa-2 d-flex"
                            >
                                <v-img
                                    class="mb-1"
                                    width="22"
                                    max-height="22"
                                    style="margin: 0 -10px 0 -20px"
                                    contain
                                    rounded
                                    data-aos="zoom-in"
                                    :src="getGameSrc(favorite.tab)"
                                ></v-img>
                                <span class="text-left flex-grow-1">
                                    {{ favorite.tab }}
                                </span>
                            </v-tab>
                            <v-divider :key="'divider'"></v-divider>
                            <!-- betiing cards -->

                            <v-list class="mt-0 pt-0">
                                <template
                                    v-for="(fixture, j) in favorite.fixtures"
                                >
                                    <v-list-item
                                        :key="j"
                                        class="px-1 white"
                                        light
                                        :to="`/sportsbook/${getEventName(
                                            fixture.eventType.name
                                        )}/${fixture.competitionId}/${
                                            fixture.parentCategory._id
                                        }/${fixture.parentCategory.betfairId}`"
                                    >
                                        <v-list-item-content
                                            class="text-center"
                                        >
                                            <v-list-item-title>
                                                <v-list-item-subtitle
                                                    class="overtext-removed"
                                                    style="font-size: 12px"
                                                >
                                                    {{ fixture.eventName }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    class="pb-2"
                                                >
                                                    <span
                                                        v-if="
                                                            getTitle(
                                                                fixture.marketStartTime
                                                            )
                                                        "
                                                        style="font-size: 10px"
                                                    >
                                                        {{
                                                            getTitle(
                                                                fixture.marketStartTime
                                                            )
                                                        }}
                                                    </span>
                                                </v-list-item-subtitle>
                                            </v-list-item-title>
                                            <v-divider
                                                :key="
                                                    'divider' +
                                                    fixture.parentCategory._id
                                                "
                                            ></v-divider>
                                            <item-odds
                                                class="center"
                                                :runners="
                                                    fixture &&
                                                    fixture.runners &&
                                                    Array.isArray(
                                                        fixture.runners
                                                    ) &&
                                                    fixture.runners.length <= 0
                                                        ? [
                                                              {
                                                                  name: fixture.eventName
                                                              }
                                                          ]
                                                        : fixture.runners
                                                "
                                                :market-id="fixture.betfairId"
                                                :to="
                                                    fixture.eventId
                                                        ? `/sportsbook/${getEventName(
                                                              favorite.tab
                                                          )}/${
                                                              fixture
                                                                  .parentCategory
                                                                  .parentCategory
                                                          }/${
                                                              fixture
                                                                  .parentCategory
                                                                  ._id
                                                          }/${fixture.eventId}`
                                                        : `/sportsbook/${getEventName(
                                                              favorite.tab
                                                          )}/${
                                                              fixture
                                                                  .parentCategory
                                                                  .parentCategory
                                                          }/${
                                                              fixture
                                                                  .parentCategory
                                                                  ._id
                                                          }`
                                                "
                                                :market="fixture"
                                                :two-odds="twoOdds"
                                                :bookmaker="
                                                    fixture.name !==
                                                    'Match Odds'
                                                "
                                                favorite-odds
                                            ></item-odds>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider
                                        :key="
                                            'divider' +
                                            fixture.parentCategory._id
                                        "
                                    ></v-divider>
                                </template>
                            </v-list>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>
<script>
import { kebabCase } from "lodash"
import { mapState } from "vuex"
// import SectionHead from '@/components/SectionHead'
// import FavoriteBtn from '@/components/FavoriteBtn'
import ItemOdds from "@/components/ItemOdds"
import socket from "@/plugins/socket.client"
import horse from "@/assets/images/menu/horse.webp"
import greyhound from "@/assets/images/sportsbook-categories/greyhound.webp"
export default {
    components: {
        // SectionHead
        ItemOdds
        // FavoriteBtn
    },
    middleware: "validateUser",
    data() {
        return {
            refresh: true,
            twoOdds: true,
            tabs: 0,
            horse,
            greyhound,
            kebabCase
        }
    },
    computed: {
        ...mapState({
            favorites: (state) => state.favorites.data,
            loading: (state) => state.favorites.loading,
            isEmpty: (state) => state.favorites.isEmpty,
            matchIds: (state) => state.favorites.matchIds,
            selectedBetfairId: (state) => state.placeBet.runner
        })
    },
    async created() {
        try {
            if (this.$auth.loggedIn) {
                await this.$store.dispatch("favorites/get")
            }
            this.$store.dispatch(
                "socketFavorite/joinRooms",
                socket.rateSocket.id
            )
            if (this.$auth.loggedIn && this.matchIds.length > 0) {
                await this.$store.dispatch(
                    "betBooks/getAll",
                    this.matchIds,
                    this.refresh
                )
            }
        } catch (error) {}
    },
    beforeDestroy() {
        this.$store.dispatch("socketFavorite/leaveRooms")
    },
    methods: {
        openAll(v) {
            return [...v.keys()].map((k, i) => i)
        },
        getIcon(text) {
            try {
                // const imgURL = '@/assets/images/sportsbook-categories/cricket.webp'
                return require(`@/assets/images/sportsbook-categories/${text
                    .replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
                    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
                    .toLowerCase()}.webp`)
            } catch (error) {
                return ""
            }
        },
        getTitle(startTime) {
            const fixturedate = this.$moment(startTime)
            if (this.$moment().isSame(this.$moment(fixturedate), "week")) {
                return this.$moment(fixturedate).calendar()
            } else {
                return this.$moment(fixturedate).format("dddd, DD/MM hh:mm A")
            }
        },
        getGameSrc(game) {
            if (game) {
                switch (game.toLowerCase()) {
                    case "horse racing":
                    case "horse-racing":
                        return this.horse
                    case "greyhound racing":
                    case "greyhound-racing":
                        return this.greyhound
                    default:
                        return this.getIcon(game)
                }
            }
        },
        getEventName(name) {
            if (
                [
                    "horse racing",
                    "horse-racing",
                    "greyhound racing",
                    "greyhound-racing"
                ].includes(name.toLowerCase())
            ) {
                return this.kebabCase(name)
            }
            return name
        }
    }
}
</script>
